export default __webpack_public_path__ + "37af206d99baa3ce0b7e28d30483f8b7.svg";